import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Tab,
  Header,
  Form,
  Menu,
  Dropdown,
} from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { Activity } from '../../../app/models/activity';
import { DeliveryRequest } from '../../../app/models/deliveryRequest';
import { OrderInitialState, Orders } from '../../../app/models/orders';
// import { } from '../../../../app/models/template';
import { store, useStore } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import CreateOrderForm from '../../Dashboard/Receiving/CreateOrder/CreateOrderForm';
import DashboardTemplateCard from '../../Dashboard/Receiving/CreateOrder/DashboardTemplateCard';
import {
  WorkflowElement,
  Communication,
  WorkflowOptions,
  Template,
  tempApi,
  WorkFlowSubTasks,
} from '../../../app/models/template';
import CreateOrderSaveFunction from '../../Dashboard/Receiving/CreateOrder/CreateOrderSaveFunction';
import agent from '../../../app/api/agent';
import { observer } from 'mobx-react-lite';

function ViewpageCreateOrder() {
  const {
    dashboardStore,
    activityStore,
    TemplateStore,
    userStore,
    mediaAssetStore,
    commonStore,
  } = useStore();

  const { loadTemplateIdForCR, selectedTemplate, viewpageCreateOrderload } =
    TemplateStore;
  const [typeSearch, setTypeSearch] = useState<string>('');
  const [itemLevel, setItemLevel] = useState<Activity | undefined>();
  const [orderState, setOrderState] = useState<Orders>(OrderInitialState);
  const [deliveryData, setDeliveryData] = useState<
    DeliveryRequest | undefined
  >();
  const [templateSelected, SetTemplateSelected] = useState<
    Template | undefined
  >(selectedTemplate);
  // const [clonedTemplate, setClonedTemplate] = useState(false);
  const [customerSelected, setCustomerSelected] = useState('');
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [departmentClear, setDepartmentClear] = useState('');
  const [taskSubtaskFound, setTaskSubtaskFound] = useState(false);
  const [customazationTrigger, setCustomazationTrigger] = useState(false);
  const [templateOptions, setTemplateOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  const { user } = userStore;

  useEffect(() => {
    let taskLength = 0;
    let subtaskLength = 0;

    if (templateSelected) {
      taskLength =
        templateSelected?.tasks &&
        templateSelected?.tasks.filter((x) => x.isActive === true).length;
      templateSelected?.tasks
        .filter((y) => y.isActive === true)
        .forEach((x) => {
          if (x?.subTasks && x?.subTasks?.length > 0) {
            subtaskLength = x.subTasks.filter(
              (z) => z.isActive === true,
            ).length;
          }
        });
    }

    if (taskLength > 0 && subtaskLength > 0) {
      setTaskSubtaskFound(true);
    } else {
      setTaskSubtaskFound(false);
    }
  }, [
    templateSelected,
    dashboardStore.dashboard.CreateOrderTemplate,
    typeSearch,
  ]);

  useEffect(() => {
    let activity = activityStore.selectedActivity;
    setTypeSearch('');
    if (activity) {
      setItemLevel(activity);
      if (activity?.elementtypeid !== undefined) {
        TemplateStore.loadElementTypeById(activity?.elementtypeid);
      }
      if (activity?.itemDeliveryRequest) {
        setDeliveryData(
          activity?.itemDeliveryRequest?.filter(
            (i) => i.isActive === true,
          )?.[0],
        );
      } else {
        setDeliveryData(undefined);
      }
    }
    // eslint-disable-next-line
  }, [activityStore.selectedActivity]);

  useEffect(() => {
    const filteredTemplate =
      TemplateStore?.selectedElementTypes?.templateTypes.filter((x) =>
        // dashboardStore.dashboard.selectedUserRoleId.includes(x.templateId),
        commonStore.filterModeOne.includes(x.templateId),
      );

    const tempOptions =
      filteredTemplate?.map((x) => ({
        key: x.templateId,
        text: x.templateName,
        value: x.templateName + '/' + x.templateId,
      })) || [];
    setTemplateOptions(tempOptions);
    // eslint-disable-next-line
  }, [
    TemplateStore?.selectedElementTypes?.templateTypes,
    dashboardStore.dashboard.selectedUserRoleId,
  ]);

  ///////////////////////handle Select
  const handleSelect = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setTypeSearch('');
      setOrderState(OrderInitialState);
      SetTemplateSelected(undefined);
    } else {
      setTypeSearch(data.value.split('/')[0]);
      loadTemplateIdForCR(data.value.split('/')[1]);
      store.TemplateStore.loadingTemplate = true;
      const oldArr = {
        ...orderState,
        templateId: data.value,
      };
      setOrderState(oldArr);

      setTimeout(() => {
        setCustomazationTrigger(true);
      }, 500);
    }
  };
  ///////////For Client and Department
  useEffect(() => {
    const oldArr: any = {
      ...orderState,
      customerId:
        dashboardStore.dashboard.createOrderClientId || user?.customerName,
      departmentId: dashboardStore.dashboard.createOrderDepartmentId,
    };
    setOrderState(oldArr);
    // eslint-disable-next-line
  }, [
    dashboardStore.dashboard.createOrderClientId,
    dashboardStore.dashboard.createOrderDepartmentId,
  ]);
  //Template Dropdown ----------------------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>
  const panes = [
    {
      menuItem: (
        userLanguage[0].Level3InventoryRecievingCreateOrder?.IRCOTPL01 as any
      )?.[`${commonStore.language.key}`], //Template
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <Menu>
            <Dropdown
              placeholder={
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCODD02 as any
                )?.[`${commonStore.language.key}`]
              } //"Type"
              fluid
              selection
              options={templateOptions}
              clearable
              search
              onChange={handleSelect}
              value={typeSearch}
              searchQuery={typeSearch}
              loading={viewpageCreateOrderload}
            />
          </Menu>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        userLanguage[0].Level3InventoryRecievingCreateOrder?.IRCOTPL02 as any
      )?.[`${commonStore.language.key}`], //"Customization"
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <DashboardTemplateCard templateSelected={templateSelected} />
        </Tab.Pane>
      ),
    },
  ];
  //////////////  Selected Template UseEffect
  useEffect(() => {
    if (selectedTemplate) {
      const NewIdGenerate = uuid();
      const temp = {
        ...selectedTemplate,
        tasks: [...selectedTemplate.tasks],
      };
      temp.templateId = NewIdGenerate;
      temp.tasks.forEach((task: any) => {
        task.taskId = uuid();
        task.isCurrentTask = false;

        task?.subTasks?.forEach((subtasks: WorkFlowSubTasks) => {
          subtasks.subTaskId = uuid();
          subtasks.isCurrentSubtask = false;
          subtasks.communication.forEach((communication: Communication) => {
            communication.id = uuid();
          });
          subtasks.api.forEach((tempApi: tempApi) => {
            tempApi.id = uuid();
          });
          subtasks.elements.forEach((element: WorkflowElement) => {
            element.elementId = uuid();
            element.options.forEach((options: WorkflowOptions) => {
              options.optionId = uuid();
            });
          });
        });
      });
      dashboardStore.updateCreateOrderTemplate(temp);
      SetTemplateSelected(temp);
    }
    // eslint-disable-next-line
  }, [selectedTemplate, customazationTrigger]);

  const handleSelecst = (e: any, data: any) => {
    if (data.name === 'customerId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderClientId = data.value;
        setCustomerSelected(e.target.textContent);
      } else {
        setCustomerSelected('');
      }
    }
    if (data.name === 'departmentId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderDepartmentId = data.value;
        setDepartmentSelected(e.target.textContent);
        setDepartmentClear(data.value);
      } else {
        setDepartmentSelected('');
        setDepartmentClear('');
      }
    }
  };
  const handleCancel = () => {
    setDepartmentSelected('');
    setDepartmentClear('');
    SetTemplateSelected(undefined);
    setTypeSearch('');
  };
  const createBtnFunc = async () => {
    mediaAssetStore.mediaAsset.isViewPageCreaterLoading = true;
    dashboardStore.dashboard.L2CardValueInventory = 'Receiving';
    CreateOrderSaveFunction(itemLevel, orderState, deliveryData);
    templateSelected?.tasks?.forEach((d) => {
      if (d.isActive) dashboardStore.dashboard.taskTotal += 1;
    });
    dashboardStore.dashboard.prodCount += 1;
    dashboardStore.dashboard.prodPlanTableLength += 1;
    await agent.updateCountOrder.updateCount(store?.userStore?.user?.id || '');
  };

  return (
    <Modal
      style={{ paddingLeft: '10px', paddingBottom: '10px' }}
      onOpen={() =>
        (mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen = true)
      }
      open={mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen}
      onClose={() =>
        (mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen = false)
      }
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content={
          (
            userLanguage[0].Level3InventoryRecievingCreateOrder?.IRCOL01 as any
          )?.[`${commonStore.language.key}`]
        }
        sub
        color="grey"
      />
      <div className="create-order-height">
        <CreateOrderForm
          handleSelect={handleSelecst}
          customerSelected={customerSelected}
          departmentSelected={departmentSelected}
          departmentClear={departmentClear}
          name={'ViewpageOrder'}
        />
        <Form>
          <Tab
            panes={panes}
            onClick={() => {
              setCustomazationTrigger(true);
            }}
          />
        </Form>
        <Button.Group
          style={{
            marginTop: '8px',
            float: 'right',
          }}
          size="small"
        >
          {/* Cancel */}
          <Button
            onClick={() => {
              handleCancel();
              mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen = false;
            }}
          >
            {
              (
                userLanguage[0].Level3InventoryRecievingCreateOrder
                  ?.IRCOB02 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
          <Button.Or
            text={
              (
                userLanguage[0].Level3InventoryRecievingCreateOrder
                  ?.IRCOB03 as any
              )?.[`${commonStore.language.key}`]
            }
          />
          {/* Save */}
          <Button
            positive
            loading={mediaAssetStore.mediaAsset.isViewPageCreaterLoading}
            onClick={createBtnFunc}
            disabled={
              departmentSelected === '' ||
              typeSearch === '' ||
              !taskSubtaskFound
            }
          >
            {
              (
                userLanguage[0].Level3InventoryRecievingCreateOrder
                  ?.IRCOB04 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
        </Button.Group>
      </div>
    </Modal>
  );
}
export default observer(ViewpageCreateOrder);
